import "./css/supported.css";

export default function Supported() {

    return (
        <>
            <section className="section-Organizer pt-0 position-relative pull-top">
                <div className="container">
                        <h1 className="fw-bold text-center">Organized By</h1>
                    <div className="box p-3 bg-white">
                        <div className="row text-center mx-auto">
                            <div className="logo-iysa col-lg-4 col-md-4 mt-5 mt-lg-0">
                                <img className="" src="images/logo/iysa.png" alt=""/>
                            </div>
                            <div className="logo-teknikundip col-lg-2 mt-5 mt-lg-0 text-center">
                                <img className="" src="/images/icons/Logo_UIN_Sunan_Kalijaga_rl5l5b.png" alt=""/>
                            </div>
                            {/* <div className="Logo-Support col-lg-4 col-md-4 mt-5 mt-lg-0">
                                <img className="" src="images/logo/buca.png" alt=""/>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-Supported pt-0 position-relative pull-top">
                <div className="container">
                        <h1 className="fw-bold text-center">Supported By</h1>
                    <div className="box p-3 bg-white">
                        <div className="row text-center mx-auto">
                            <div className="logo-miica col-lg-4 col-md-4 mt-5 mt-lg-0">
                                <img className="" src="images/logo/miica.png" alt=""/>
                            </div>
                            {/* <div className="logo-aktuaria col-lg-4 mt-5 mt-lg-0 text-center">
                                <img className="" src="images/logo/LogoAKTUARIA.png" alt=""/>
                            </div> */}
                            {/* <div className="Logo-newera col-lg-4 col-md-4 mt-5 mt-lg-0">
                                <img className="" src="images/logo/NWERA.png" alt=""/>
                            </div> */}
                            <div className="Logo-newera col-lg-6 col-md-4 mt-5 mt-lg-0">
                                <img className="" src="/images/icons/imsef_kuoxjp.png" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
